// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"4":"04208259","27":"9807f6ad","35":"035ab33d","88":"6a9ef9fb","151":"9406380c","276":"b5fff681","306":"3b846bbd","362":"cad4105e","537":"d3884f0a","596":"fa1e6db2","740":"48374e76","863":"79ee00e2","884":"1efa91a0","930":"67f1c304","961":"1a40c614","966":"9610b7fb"}[chunkId] + ".js";
};